import styled from "styled-components";

export const StyledDiv = styled.div`
  padding-left: 5px;
  cursor: pointer;
`;
